<template>
  <div>
    <v-checkbox
      :hide-details="
        question.HideDetails != null ? question.HideDetails : 'auto'
      "
      :class="[question?.StyleClass]"
      class="d-inline-flex checkbox"
      v-model="question.Value"
      :rules="getRules"
      :label="question.AnswerControlLabel"
    ></v-checkbox>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";

export default {
  name: "CheckboxBase",
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox:deep(.v-label) {
  color: inherit;
  font-weight: bold;
}
</style>
